import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { uniqObjectMerge } from '../../utils/arrayUtils';
import { IDepartingSoonFetchRequest, IDepartingSoonItem } from './departingSoonInterfaces';

export interface IDepartingSoonState {
  readonly items: IDepartingSoonItem[];
}

const initialState: IDepartingSoonState = {
  items: []
};

//tslint:disable no-empty
const departingSoonSlice = createSlice({
  initialState,
  name: 'departingSoon',
  reducers: {
    fetch: (state, action: PayloadAction<IDepartingSoonFetchRequest>) => {},
    removeItems: {
      prepare: (shipmentItemIds: number[]) => ({ payload: { shipmentItemIds } }),
      reducer: (state, action: PayloadAction<{ shipmentItemIds: number[] }>) => {
        state.items = state.items.filter(x => !action.payload.shipmentItemIds.includes(x.shipmentItemId));
      }
    },
    removeLoad: {
      prepare: (loadNumber: string) => ({ payload: { loadNumber } }),
      reducer: (state, action: PayloadAction<{ loadNumber: string }>) => {
        state.items = state.items.filter(x => x.loadNumber !== action.payload.loadNumber);
      }
    },
    removeShipment: {
      prepare: (shipmentId: number) => ({ payload: { shipmentId } }),
      reducer: (state, action: PayloadAction<{ shipmentId: number }>) => {
        state.items = state.items.filter(x => x.shipmentId !== action.payload.shipmentId);
      }
    },
    setItems: (state, action: PayloadAction<IDepartingSoonItem[]>) => {
      state.items = uniqObjectMerge(state.items, action.payload, x => x.shipmentItemId);
    }
  }
});

export const { actions: departingSoonActionCreators, reducer: departingSoonReducer } = departingSoonSlice;
